<template>
    <nav
        v-qa="'header-menu'"
        class="header-menu"
        :class="classHeaderMenuMobileWrapper"
        data-allow-mismatch
    >
        <HeaderMenuDesktop
            :main-menu
            @close-menu-mobile="closeMenuMobile"
            @toggle-login-form="toggleLoginForm"
        />
    </nav>
</template>

<script setup lang="ts">
import { computed, defineAsyncComponent } from 'vue'
import type { HeaderMenuFragment } from '@/graphql/api'

const HeaderMenuDesktop = defineAsyncComponent({
    loader: () => import('./HeaderMenuDesktop.vue'),
})

const props = defineProps<{
    mainMenu: HeaderMenuFragment[]
    isMenuMobileOpen: boolean
}>()

const emit = defineEmits<{
    'toggle-login-form': []
    'close-menu-mobile': []
    'open-menu-mobile': []
}>()

const closeMenuMobile = () => emit('close-menu-mobile')

const toggleLoginForm = () => {
    emit('toggle-login-form')

    closeMenuMobile()
}

const classHeaderMenuMobileWrapper = computed(() => ({
    'mobile-menu-open': props.isMenuMobileOpen,
}))
</script>

<style lang="scss" scoped>
.header-menu {
    display: none;

    &.mobile-menu-open {
        display: block;
        position: fixed;
        width: 100%;
        left: 0;
        top: 0;
        bottom: 0;
        height: 100vh;
        z-index: 100;
        overflow-y: auto;
        padding-bottom: 50px;
        -webkit-overflow-scrolling: touch;
        color: $slate;
        background-color: $stone-3;
        user-select: none;
    }

    @include min-width(1024) {
        display: block;
    }

    .header-menu-mobile-wrapper {
        position: fixed;
        width: 100%;
        bottom: 0;
        height: 100vh;
        left: 0;
        top: 0;
        pointer-events: none;

        @include min-width(1024) {
            display: none;
        }

        &.mobile-menu-open {
            pointer-events: auto;
        }
    }
}

.slide-enter-active,
.slide-leave-active,
.slide-reverse-enter-active,
.slide-reverse-leave-active {
    transition: transform 175ms var(--timing-function-easing-accelerate);
}

.slide-enter-from,
.slide-reverse-leave-to {
    transform: translate3d(100%, 0, 0);
}

.slide-leave-to,
.slide-reverse-enter-from {
    transform: translate3d(100%, 0, 0);
}
</style>
